import { isUndNullEmp } from '../../helpers/main.js';

export class Country {
    constructor(
        _id = 0,
        _secundaryId = '',
        _name = '',
        _register = '',
    ) {
        this.id = _id;
        this.secundaryId = _secundaryId;
        this.name = _name;
        this.register = _register;
    }

    static getClassName = () => {
        return 'Country - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 10,
                    SecundaryId: 2,
                    Name: 10,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    SecundaryId: 2,
                    Name: 30,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 10,
                    secundaryId: 2,
                    name: 10,
                    register: 10,
                },
                max: {
                    id: 450,
                    secundaryId: 2,
                    name: 20,
                    register: 30,
                },
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: Country.getClassName() })?.result) {
            if (upperCase) {
                return new Country(
                    obj.Id,
                    obj.SecundaryId,
                    obj.Name,
                    obj.Register,
                );
            } else {
                return new Country(
                    obj.id,
                    obj.secundaryId,
                    obj.name,
                    obj.register,
                );
            }
        } else {
            return new Country();
        }
    }
}